module.exports = __webpack_public_path__ + "static/media/enterprise_plus_profile_icon.9b0a724e.svg";